import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

export default function ProductUnits() {
  const [units, setUnits] = useState([]);
  const [form, setForm] = useState({
    name: "",
    short_name: "",
  });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const loadUnits = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch(`${API_BASE}/masters/product-units`, {
        headers: authHeaders(),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to load units");
      }

      setUnits(Array.isArray(data.data) ? data.data : []);
    } catch (err) {
      console.error("Load units error:", err);
      setMessage(err.message || "Failed to load units");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUnits();
  }, []);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!form.name.trim()) {
      setMessage("Unit name is required");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/masters/product-units`, {
        method: "POST",
        headers: authHeaders({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok || data.success === false) {
        throw new Error(data.message || "Failed to create unit");
      }

      setForm({
        name: "",
        short_name: "",
      });

      setMessage("Unit created successfully");
      loadUnits();
    } catch (err) {
      console.error("Create unit error:", err);
      setMessage(err.message || "Failed to create unit");
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />

      <div style={{ padding: 24, width: "100%" }}>
        <h2>Product Unit Master</h2>

        <p style={{ color: "#555" }}>
          Super Admin can create common product units. FPO Admins will only select from this list.
        </p>

        {message && (
          <div
            style={{
              marginBottom: 16,
              padding: 10,
              background: "#f5f5f5",
              border: "1px solid #ddd",
            }}
          >
            {message}
          </div>
        )}

        <form
          onSubmit={handleCreate}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr auto",
            gap: 10,
            alignItems: "end",
            marginBottom: 24,
            maxWidth: 750,
          }}
        >
          <div>
            <label>Unit Name *</label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="e.g. Kilogram, Bag, Bottle"
              style={{ width: "100%", padding: 8 }}
            />
          </div>

          <div>
            <label>Short Name</label>
            <input
              name="short_name"
              value={form.short_name}
              onChange={handleChange}
              placeholder="e.g. Kg, Bag, Btl"
              style={{ width: "100%", padding: 8 }}
            />
          </div>

          <button
            type="submit"
            style={{
              padding: "9px 14px",
              background: "#1976D2",
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
          >
            Create
          </button>
        </form>

        <h3>Unit List</h3>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <table
            border="1"
            cellPadding="8"
            cellSpacing="0"
            style={{ borderCollapse: "collapse", width: "100%", maxWidth: 800 }}
          >
            <thead>
              <tr style={{ background: "#f0f0f0" }}>
                <th>ID</th>
                <th>Unit Name</th>
                <th>Short Name</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {units.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No unit found
                  </td>
                </tr>
              ) : (
                units.map((unit) => (
                  <tr key={unit.id}>
                    <td>{unit.id}</td>
                    <td>{unit.name}</td>
                    <td>{unit.short_name || "-"}</td>
                    <td>{unit.is_active ? "Active" : "Inactive"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}